/**
 * Route gate: platform admin OR clinicalHudAccess grant.
 *
 * Unsigned visitors go to sign-in with a return path. Signed-in accounts
 * without a grant go to request-access — never back through /auth or the
 * splash Sign in button (that loop looks like a failed login on iOS).
 */
import { Navigate, useLocation } from 'react-router-dom';
import Loading from 'components/Loading';
import { useAuth } from 'hooks/useAuth';
import { useClinicalHudAccess } from '../hooks/useClinicalHudAccess';
import {
  authPath,
  marketingPagePath,
} from 'features/clinicalHud/marketing/clinicalHudMarketingRouting';

export default function RequireClinicalHudAccess({ children }) {
  const { user } = useAuth();
  const { canAccess, loading } = useClinicalHudAccess();
  const location = useLocation();

  if (loading) return <Loading page />;
  if (canAccess) return children;
  if (!user) {
    const next = `${location.pathname}${location.search}`;
    return <Navigate to={authPath({ next })} replace />;
  }
  return <Navigate to={marketingPagePath('request-access')} replace />;
}
